export default "__VITE_ASSET__C7BN3ix8__"